<template>
  <div class="auth-project-container">
    <b-modal id="auth-project-modal" ref="modal" hide-footer centered>
      <template slot="modal-header">
        <div class="m-modal-header">
          <h2 class="top-title mb-0">中意网供应商认证申请</h2>
          <img
            src="@/assets/images/icon_modal_close.png"
            alt
            class="close-button"
            @click.stop="hide"
          />
        </div>
      </template>
      <template slot="default">
        <div class="m-modal-content">
          <form>
            <h2 class="title">项目经验</h2>
            <fieldset>
              <span class="name">项目名称：</span>
              <input
                type="text"
                placeholder="请输入项目名称"
                v-model="experienceName"
              />
            </fieldset>
            <fieldset>
              <span class="name"> 项目时间：</span>
              <select name="type" id="year" v-model="year">
                <option
                  :value="item"
                  v-for="(item, index) in years"
                  :key="index"
                  >{{ item }}</option
                >
              </select>
              <span>年</span>
              <select name="type" id="month" class="ml-3" v-model="month">
                <option
                  :value="item"
                  v-for="(item, index) in months"
                  :key="index"
                  >{{ item }}</option
                >
              </select>
              <span>月</span>
            </fieldset>
            <!-- <fieldset>
              <span class="name">项目岗位：</span>
              <input
                type="text"
                placeholder="请输入项目岗位"
              />
            </fieldset> -->
            <fieldset>
              <span class="name">项目介绍：</span>
              <textarea
                name=""
                cols="30"
                rows="3"
                placeholder="请输入项目介绍"
                v-model="experienceIntroduce"
              ></textarea>
            </fieldset>
            <div class="agreement">
              <input
                type="checkbox"
                name="agreement"
                id="agreement"
                class="mr-2"
              />
              <label for="agreement">
                <span class="text">我已阅读</span>
              </label>
              <span class="link" @click="showAgreement"
                >《供应商认证协议》</span
              >
            </div>
          </form>
          <button
            class="confirm-button d-block mx-auto my-5"
            @click.stop="submit"
          >
            提交
          </button>
        </div>
      </template>
    </b-modal>
    <vendor-agreement-modal ref="agreementModal"></vendor-agreement-modal>
  </div>
</template>
<style lang="scss" scoped>
#auth-project-modal {
  width: 60%;
  .m-modal-header {
    width: 100%;
    display: flex;
    align-items: center;
    .top-title {
      flex: 1;
      font-size: 1.25rem;
      color: #333333;
      text-align: left;
      border-left: 0.19rem $acentColor solid;
      padding-left: 0.5rem;
    }
    .close-button {
      color: $acentColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .m-modal-content {
    .title {
      font-size: 1.25rem;
      color: #333333;
      font-weight: bold;
      margin-bottom: 1.5rem;
    }
    form {
      fieldset {
        margin-bottom: 1rem;
        span.name,
        option.name {
          font-size: 1.13rem;
          color: #333333;
          vertical-align: top;
          display: inline-block;
          height: 2.38rem;
          display: inline-block;
        }
        input[type='text'],
        select,
        textarea {
          width: 80%;
          padding-left: 0.5rem;
          outline: none;
          border: solid 0.06rem #e5e5e5;
          resize: none;
          &::placeholder {
            font-size: 1.13rem;
            color: #999999;
          }
        }

        input[type='text'],
        select {
          height: 2.38rem;
        }
        select {
          height: 2.38rem;
          width: 20%;
          margin-right: 0.25rem;
        }
        .upload-img-block {
          display: inline-block;
          width: 75%;
          .item {
            display: inline-block;
            .upload-img {
              margin-bottom: 0.8rem;
            }
            .upload-button {
              display: block;
              margin: 0 auto;
              padding: 0.4rem 0.5rem;
              background-color: white;
              border: solid 0.06rem $acentColor;
              color: $acentColor;
            }
          }
        }
      }
      .agreement {
        margin-bottom: 1.2rem;
        .text {
          font-size: 0.88rem;
          color: #999999;
        }
        .link {
          color: $acentColor;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .confirm-button {
      font-size: 1.25rem;
      color: white;
      width: 60%;
      height: 2.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $acentColor;
      border: none;
      outline: none;
    }
  }
}
</style>

<script>
import VendorAgreementModal from '@/components/VendorAgreementModal';
export default {
  data() {
    return {
      years: Array(20)
        .fill(2000)
        .map((v, i) => v + i),
      months: Array(12)
        .fill(1)
        .map((v, i) => v + i),
      year: '',
      month: '',
      experienceName: '',
      experienceIntroduce: ''
    };
  },
  computed: {
    experienceTime() {
      return `${this.year}.${this.month}`;
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    submit() {
      let project = {};

      this.$emit('submit', { project });
    },
    showAgreement() {
      this.$refs.agreementModal.show();
    }
  },
  components: {
    VendorAgreementModal
  }
};
</script>
